import { Popup } from 'semantic-ui-react';

export default class CloseablePopup extends Popup {
  private mounted?: boolean;

  constructor(props) {
    super(props);

    this.close = this.close.bind(this);
  }

  componentDidMount(): void {
    this.mounted = true;
  }

  componentWillUnmount(): void {
    this.mounted = false;
  }

  close() {
    this.setState({ closed: true });
    // make sure that the component is still mounted before setting its state
    setTimeout(() => {
      if (!!this.mounted) {
        this.setState({ closed: false });
      }
    }, 50);
  }
}
